import styled from "@emotion/styled";
import { Spacer } from "../../layout";
import { labelStyles } from "./FormLabelLabel";
const shouldForwardPropToBaseComponent = prop => {
  switch (prop) {
    // Add any props that should NOT be forwarded to Base Component here.
    case "themeMode":
      return false;
    default:
      return true;
  }
};
export const FormLabelFeedback = styled(Spacer, {
  shouldForwardProp: shouldForwardPropToBaseComponent
})`
    &:not(:empty) {
        margin-top: ${_ref => {
  let {
    themeMode
  } = _ref;
  return labelStyles.margin(themeMode);
}}px;
    }
`;
//# sourceMappingURL=FormLabelFeedback.js.map